/* eslint-disable prettier/prettier */
/* eslint-disable no-useless-escape */
import Joi from "joi";

export const forgotValidation = Joi.object({
  Email: Joi.string().email({ tlds: { allow: false } }),
  Language: Joi.string().valid('en', 'fr', 'es').optional(),
}).and("Email");

export const resetValidation = Joi.object({
  Password: Joi.string().alphanum().min(2).max(30).required(),
  encPassword: Joi.string().alphanum().min(2).required(),
  Email: Joi.string().email({ tlds: { allow: false } }),
  Key: Joi.string().alphanum().length(12).required(),
  RepeatPassword: Joi.string().alphanum().min(2).max(30).required(),
  encRepeatPassword: Joi.string().alphanum().min(2).required(),
}).and(
  "Password",
  "encPassword",
  "Email",
  "RepeatPassword",
  "encRepeatPassword"
);

export const loginValidation = Joi.object({
  Email: Joi.string().email({ tlds: { allow: false } }).messages({
    'string.email': "login.login_section.error_messages.email_not_valid"
  }),
  Password: Joi.string()
    .regex(/^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};:\\|,.<>\/?~]+$/)
    .min(2)
    .max(30)
    .required()
    .messages({
      "string.pattern.base": `login.login_section.error_messages.password`,
      'string.min': "login.login_section.error_messages.password_too_short",
      'string.max': "login.login_section.error_messages.password_too_long",
    }),
  encPassword: Joi.string().alphanum().min(2).required(),
  accountValue: Joi.any(),
  instructor: Joi.any(),
}).and("Email", "Password", "encPassword");
export const reLoginValidation = Joi.object({
  Email: Joi.string().email({ tlds: { allow: false } }).messages({
    'string.email': "login.login_section.error_messages.email_not_valid"
  }),
}).and("Email");

export const empty = (value) => {
  // null and undefined will result an error in the typeof function
  if (value === null || value === undefined) {
    return true;
  }
  switch (typeof value) {
    case "string":
      if (value == "" || value.trim() === "") {
        return true;
      }
      break;
    case "object":
      if (Array.isArray(value) && !value.length) {
        return true;
      }

      if (!Object.keys(value).length) {
        return true;
      }
      break;
    default:
      // need to add validation to the default
      if (value == "") {
        return true;
      }

      break;
  }

  return false;
};
export const loginValidationConference = Joi.object({
  Email: Joi.string().email({ tlds: { allow: false } }),
}).and("Email");
